import React, { useCallback } from "react";

import algoliasearch from "algoliasearch/lite";
import PropTypes from "prop-types";
import { InstantSearch } from "react-instantsearch-dom";

const SEARCH_INDICES = [
  {
    name: `Resource hub data`,
    title: `Resource hub data`,
    slug: "Resource hub data",
  },
];

const algoliaClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_KEY
);

const searchClient = {
  ...algoliaClient,
  search(requests) {
    // detect empty search & do nothing
    // https://www.algolia.com/doc/guides/building-search-ui/going-further/conditional-requests/react/#detecting-empty-search-requests
    if (
      requests.every(({ params }) => {
        return !params.query;
      })
    ) {
      return null;
    }

    return algoliaClient.search(requests);
  },
};

function SearchProvider({ children, callbackToUpdateQueryState }) {
  const updateQueryState = useCallback(
    ({ query }) => {
      if (callbackToUpdateQueryState) {
        callbackToUpdateQueryState((currentState) => {
          if (query !== currentState) {
            return query;
          }
          return null;
        });
      }
    },
    [callbackToUpdateQueryState]
  );

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={SEARCH_INDICES[0]?.name}
      // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop
      onSearchStateChange={updateQueryState}
    >
      {children}
    </InstantSearch>
  );
}

SearchProvider.propTypes = {
  children: PropTypes.node,
  callbackToUpdateQueryState: PropTypes.func,
};

SearchProvider.defaultProps = {
  children: null,
  callbackToUpdateQueryState: () => {},
};

export default SearchProvider;
